<template>
  <div id="app" style="overflow-y: auto">
    <Header></Header>
    <router-view />
    <model v-if="menutype == 1" style="position: absolute;right: 0;"></model>
    <Footer></Footer>
    <el-dialog :visible.sync="$store.store.state.dialogVisibleImg" class="dialog_banner" width="1300px">
      <!-- <img  alt="" v-for="(imgItem, index) in $store.store.state.dialogImageUrl" :key="index"
        :src="'https://lcsy.znhospital.cn/api/sys/file/static/'+imgItem" style="max-width:100%" /> -->
      <img alt="" v-for="(imgItem, index) in $store.store.state.dialogImageUrl" :key="index"
        :src="$store.store.state.windonsrc + imgItem" style="max-width: 100%" />
    </el-dialog>
  </div>
</template>

<script>
import Footer from "@/components/footer.vue";
import Header from "@/components/header.vue";
import model from "@/components/model.vue";
import { getmenu } from "@/request/api";
export default {
  name: "App",
  components: {
    Header,
    Footer,
    model,
  },
  data() {
    return {
      arr1: [],
      arr2: [],
      arr3: [],
      menutype: "",
    };
  },
  watch: {
    $route(to, from) {
      if (this.$route.path == "/") {
        window.sessionStorage.setItem("menutype", 1);
        this.$router.push({
          path: "/",
        });
      } else if (this.$route.path == "/ethic") {
        window.sessionStorage.setItem("menutype", 2);
      } else if (this.$route.path == "/technology") {
        window.sessionStorage.setItem("menutype", 3);
      } else {
        let data = window.sessionStorage.getItem("menutype");
        window.sessionStorage.setItem("menutype", data);
      }
      this.menutype = window.sessionStorage.getItem("menutype");
    },
  },
  created() {
    if (
      window.location.href.split("?").length > 1 &&
      window.location.href.split("?")[1].indexOf("menutype") != -1
    ) {
      let arr = window.location.href.split("?")[1].split("&");
      let menutypeVal = null;
      if (arr && arr.length > 0) {
        arr.forEach((item, index) => {
          var pair = item.split("=");
          if (pair[0] == "menutype") {
            menutypeVal = pair[1];
          }
        });
      }
      this.menutype = menutypeVal;
      window.sessionStorage.setItem("menutype", menutypeVal);
    } //原判断---else
    this.menutype = window.sessionStorage.getItem("menutype");
    var windowheight = screen.height - 369;
    this.$store.store.commit("setheight", windowheight);
    if (!window.sessionStorage.getItem("menutype")) {
      window.sessionStorage.setItem("menutype", 1);
    }
    this.arr1 = [
      { menu: "首页", url: "/", children: [] },
      { menu: "中心介绍", url: "/center", children: [] },
      { menu: "通知公告", url: "/notice", children: [] },
      { menu: "办事指南", url: "/enchiridion", children: [] },
      { menu: "政策法规", url: "/policy", children: [] },
      { menu: "GCP专业科室", url: "/GCP", children: [] },
      { menu: "试验项目", url: "/recruit", children: [] },
      { menu: "下载中心", url: "/download", children: [] },
      { menu: "联系我们", url: "/contactUs", children: [] },
    ];
    this.getmenu_Fun(1, 1, 1, "/center"); // 中心介绍
    this.getmenu_Fun(1, 15, 2, "/notice"); //通知公告
    this.getmenu_Fun(1, 19, 3, "/enchiridion"); //办事指南
    this.getmenu_Fun(1, 31, 4, "/policy"); //政策法规
    this.getmenu_Fun(1, 20, 5, "/GCP"); //GCP
    this.getmenu_Fun(1, 107, 6, "/recruit"); //试验项目
    this.getmenu_Fun(1, 23, 7, "/download"); //下载中心
    this.getmenu_Fun(1, 24, 8, "/contactUs"); //联系我们
    this.arr2 = [
      { menu: "首页", url: "/ethic", children: [] },
      { menu: "伦理委员会介绍", url: "/center", children: [] },
      { menu: "通知公告", url: "/notice", children: [] },
      { menu: "办事指南", url: "/enchiridion", children: [] },
      { menu: "政策法规", url: "/policys", children: [] },

      { menu: "伦理培训", url: "/trainsession", children: [] },
      { menu: "联系我们", url: "/contactUs", children: [] },
    ];
    this.getmenu_Fun(2, 1, 1, "/center"); // 伦理委员会介绍
    this.getmenu_Fun(2, 15, 2, "/notice"); //通知公告
    this.getmenu_Fun(2, 19, 3, "/enchiridion"); //办事指南
    this.getmenu_Fun(2, 72, 4, "/policy"); //政策法规
    this.getmenu_Fun(2, 78, 5, "/trainsession"); //伦理培训
    this.getmenu_Fun(2, 24, 6, "/contactUs"); //联系我们
    this.arr3 = [
      { menu: "首页", url: "/technology", children: [] },
      { menu: "机构介绍", url: "/center", children: [] },
      { menu: "通知公告", url: "/notice", children: [] },
      // { menu: "政策法规", url: "/policy", children: [] },
      // { menu: "办事指南", url: "/enchiridion", children: [] },
      { menu: "专利推介", url: "/patentRecommendation", children: [] },
      { menu: "联系我们", url: "/contactUs", children: [] },
    ];
    this.getmenu_Fun(3, 1, 1, "/center"); // 伦理委员会介绍
    this.getmenu_Fun(3, 15, 2, "/notice"); //通知公告
    // this.getmenu_Fun(3, 19, 4, "/enchiridion"); //办事指南
    // this.getmenu_Fun(3, 88, 3, "/policy"); //政策法规
    this.getmenu_Fun(3, 97, 3, "/patentRecommendation"); //专利推介
    this.getmenu_Fun(3, 24, 4, "/contactUs"); //联系我们
  },
  methods: {
    getmenu_Fun(belongSystemId, parentMenuId, index, url) {
      let params = {
        belongSystemId: belongSystemId,
        parentMenuId: parentMenuId,
        pageSize: 100,
        pageNumber: 1,
      };
      getmenu(params)
        .then((res) => {
          if (belongSystemId == 1) {
            if (res.data.data.list && res.data.data.list.length > 0) {
              if (parentMenuId == 19) {
                this.arr1[index].url =
                  this.arr1[index].url +
                  "?id=" +
                  res.data.data.list[0].id +
                  "&index=0&menuName=" +
                  res.data.data.list[0].menuName +
                  "&menutype=1";
                res.data.data.list.forEach((item, listIndex) => {
                  if (listIndex == 2) {
                    item.url = url;
                    item.urlId = item.id;
                    item.urlIndex = 4;
                    item.menuName = item.menuName;
                  } else {
                    item.url = url;
                    item.urlId = item.id;
                    item.urlIndex = listIndex;
                    item.menuName = item.menuName;
                  }
                });
                this.arr1[index].children = res.data.data.list;
                window.sessionStorage.setItem(
                  "menuList1",
                  JSON.stringify(this.arr1)
                );
              } else {
                this.arr1[index].url =
                  this.arr1[index].url +
                  "?id=" +
                  res.data.data.list[0].id +
                  "&index=0&menuName=" +
                  res.data.data.list[0].menuName +
                  "&menutype=1";
                res.data.data.list.forEach((item, listIndex) => {
                  item.url = url;
                  item.urlId = item.id;
                  item.urlIndex = listIndex;
                  item.menuName = item.menuName;
                });
                this.arr1[index].children = res.data.data.list;
              }
            } else {
              this.arr1[index].url = this.arr1[index].url + "?menutype=1";
            }
            window.sessionStorage.setItem(
              "menuList1",
              JSON.stringify(this.arr1)
            );
          } else if (belongSystemId == 2) {
            if (res.data.data.list && res.data.data.list.length > 0) {
              this.arr2[index].url =
                this.arr2[index].url +
                "?id=" +
                res.data.data.list[0].id +
                "&index=0&menuName=" +
                res.data.data.list[0].menuName +
                "&menutype=2";
              res.data.data.list.forEach((item, listIndex) => {
                item.url = url;
                item.urlId = item.id;
                item.urlIndex = listIndex;
                item.menuName = item.menuName;
              });
              this.arr2[index].children = res.data.data.list;
            } else {
              this.arr2[index].url = this.arr2[index].url + "?menutype=2";
            }
            window.sessionStorage.setItem(
              "menuList2",
              JSON.stringify(this.arr2)
            );
          } else {
            if (res.data.data.list && res.data.data.list.length > 0) {
              this.arr3[index].url =
                this.arr3[index].url +
                "?id=" +
                res.data.data.list[0].id +
                "&index=0&menuName=" +
                res.data.data.list[0].menuName +
                "&menutype=3";
              res.data.data.list.forEach((item, listIndex) => {
                item.url = url;
                item.urlId = item.id;
                item.urlIndex = listIndex;
                item.menuName = item.menuName;
              });
              this.arr3[index].children = res.data.data.list;
            } else {
              this.arr3[index].url = this.arr3[index].url + "?menutype=3";
            }
            window.sessionStorage.setItem(
              "menuList3",
              JSON.stringify(this.arr3)
            );
          }
        })
        .catch(() => { });
    },
  },
};
</script>

<style>
#app {
  position: relative;
}

.dialog_banner {
  text-align: center;
}

.dialog_banner .el-dialog__header {
  background-color: transparent;
  border-bottom: none;
}

.dialog_banner .el-dialog__body {
  margin-top: -10px;
}

.dialog_banner img {
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue